import React, { Suspense } from 'react';

import { Section } from '../../library/page/page';
import LazyLoad from '../lazy-load/lazy-load';

import './cms-sections.scss';

interface ComponentMap {
  [key: string]: (props) => JSX.Element;
}

interface CmsComponent {
  __typename: string;
}

interface CmsSection {
  cmsComponents: Array<CmsComponent>;
  name: string;
  position: string;
}

type SectionHeight = (number) => number;

interface CMSSectionsProps {
  className?: string;
  componentMap: ComponentMap;
  sectionHeight?: SectionHeight;
  sections: Array<CmsSection>;
  shouldHideHeading?: (cmsSection: object) => boolean;
  styleName?: string;
}

function CmsSections(props: CMSSectionsProps) {
  const {
    className,
    componentMap,
    sectionHeight,
    sections,
    shouldHideHeading,
    ...rest
  } = props;

  return (
    <div className={className} data-testid="cms-sections">
      {Array.isArray(sections) &&
        sections.map((cmsSection, secIdx) => (
          <LazyLoad height={sectionHeight?.(secIdx)} key={`ps-${secIdx}`}>
            <Section
              className={cmsSection?.position}
              heading={
                !shouldHideHeading?.(cmsSection) ? cmsSection?.name : undefined
              }
              styleName="cms-section"
            >
              <Suspense fallback={null}>
                {cmsSection &&
                  Array.isArray(cmsSection.cmsComponents) &&
                  cmsSection.cmsComponents.map((cmsComponent, idx) => {
                    const CMSComponent =
                      cmsComponent.__typename in componentMap
                        ? componentMap[cmsComponent.__typename]
                        : null;

                    return CMSComponent ? (
                      <CMSComponent
                        key={`cc-${idx}`}
                        {...cmsComponent}
                        {...rest}
                      />
                    ) : null;
                  })}
              </Suspense>
            </Section>
          </LazyLoad>
        ))}
    </div>
  );
}

export default CmsSections;
